import { render, staticRenderFns } from "./OrgForm.vue?vue&type=template&id=3351d118&lang=pug&"
import script from "./OrgForm.vue?vue&type=script&lang=js&"
export * from "./OrgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports